<template>
    <Head title="Feed" />

    <AuthenticatedLayout>
        <Heading title="Feed" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28"/>
        <div>
            <div class="flex flex-col items-center gap-y-12 px-4 pt-8 min-h-[70vh]">
                <Post v-for="(data, key) in dataPosts" :amountLike="data.amountLike" :amountComment="data.amountComment" :post="data" :postId="data.post.id" :midia="data.post.midia" :liked="data.liked" :key="key" :perfilPhoto="data.post.postProfile.avatar" :author="data.post.postProfile.name" :createdDate="data.post.startDate || data.post.createdAt" :text="data.post.text" :url="data.post.midia" />
            </div>
            <div ref="endPoint" class="flex justify-center">
                <div class="flex mt-10 mb-14">
                    <Spinner v-if="loading"/>
                </div>
            </div>
        </div>
    </AuthenticatedLayout>
</template>
<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Heading from '@/Components/UI/Texts/Heading.vue';
import { Head } from "@inertiajs/inertia-vue3";
import Post from "@/Components/Post.vue"
import Spinner from "@/Components/UI/Loaders/Spinner.vue";

export default {
    components: {
        AuthenticatedLayout,
        Heading,
        Head,
        Post,
        Spinner
    },
    props: {
        data: Object
    },
    data() {
        return {
            select: true,
            loading: false,
            page: 0,
            dataPosts: this.data,
            total: 0,
        }
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll)
    },
    methods: {
        onScroll(e) {
            const endPoint = this.$refs['endPoint'];
            const positionEndPointY = endPoint.getBoundingClientRect().y;
            const windowInnerHeight = window.innerHeight;

            if(positionEndPointY <= windowInnerHeight) {
                this.nextPage();
            }
        },
        nextPage() {
            if(this.loading) {
                return;
            }

            if(this.total && this.dataPosts.length >= this.total) {
                return;
            }

            this.loading = true;

            axios.get(route('news.get-posts'), {
                params: {
                    page: this.page + 1
                }
            })
            .then(response => {
                const responseData = response.data;
                const newPosts = responseData.data;
                const mergedPosts = [...this.dataPosts, ...newPosts];

                this.page = this.page + 1;
                this.total = response.data.total;
                this.dataPosts = mergedPosts;
                this.loading = false;
            })
            .catch(err => {
                console.log(err);
                this.loading = false;
            });
        },
    }
}
</script>
